import type {
  ObjectStoreExclusionRuleStoreTypeEnum,
  Configuration,
  ObjectStoreExclusionRule,
} from '@repo/api-gw-sdk';
import {
  ListObjectStoreExclusionRulesApi,
  CreateObjectStoreExclusionRuleApi,
  UpdateObjectStoreExclusionRuleApi,
  DeleteObjectStoreExclusionRuleApi,
} from '@repo/api-gw-sdk';
import type { ColumnSort, PaginationState } from '@tanstack/react-table';

import { toJsonText } from '@/components/queryBuilder/QueryLanguageConverter';
import { StringOperator } from '@/types/advanceFilter.ts';

import type { HttpClient } from './httpClient';

const baseUrl = '/object-store-exclusion-rules';

export const objectStoreExclusionRules = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const listObjectStoreExclusionRulesApi = new ListObjectStoreExclusionRulesApi(
    config
  );
  const createObjectStoreExclusionRuleApi =
    new CreateObjectStoreExclusionRuleApi(config);
  const updateObjectStoreExclusionRuleApi =
    new UpdateObjectStoreExclusionRuleApi(config);
  const deleteObjectStoreExclusionRuleApi =
    new DeleteObjectStoreExclusionRuleApi(config);

  return {
    list: (
      storeType: ObjectStoreExclusionRuleStoreTypeEnum | null,
      pagination?: PaginationState,
      sorting?: ColumnSort
    ) =>
      httpClient.execute(
        [baseUrl, pagination, sorting, currentProjectId, storeType],
        async () => {
          if (!storeType) {
            return;
          }

          return listObjectStoreExclusionRulesApi.listObjectStoreExclusionRules(
            currentProjectId,
            pagination?.pageIndex,
            pagination?.pageSize,
            sorting && `${sorting.id}:${sorting.desc ? 'desc' : 'asc'}`,
            toJsonText({
              type: 'String',
              operator: StringOperator.In,
              property: 'storeType',
              value: [storeType],
            })
          );
        }
      ),
    create: (rule: ObjectStoreExclusionRule) =>
      createObjectStoreExclusionRuleApi.createObjectStoreExclusionRule(
        currentProjectId,
        rule
      ),
    update: (rule: ObjectStoreExclusionRule) =>
      updateObjectStoreExclusionRuleApi.updateObjectStoreExclusionRule(
        rule.id,
        currentProjectId,
        rule
      ),
    delete: (ruleId: string) =>
      deleteObjectStoreExclusionRuleApi.deleteObjectStoreExclusionRule(
        ruleId,
        currentProjectId
      ),
  };
};
